import React, { useState, useEffect, useCallback, Component } from "react";
import { Button, LinkButton } from "../../../globals/components/button";
import {
  GameDetailsContainer,
  InfoContainer,
  StatsContainer,
  ProgressContainer,
  MenuContainer
} from "../styled_components/containers";

import { StatsBox, Stat } from "../styled_components/stats";
import novice from "../assets/novice.png";
import trophies from "../assets/trophies.png";
import rating from "../assets/rating.png";
import school_rank from "../assets/school-rank.png";
import global_rank from "../assets/global-rank.png";
import GreyGem from "../assets/Greyed_out_diamond.png";
import ShinyGem from "../assets/Shiny_Diamond.png";

import styled from "styled-components";
import useGame from "../hooks/useGame";
import useTopics from "../hooks/useTopics";

import { Scale } from 'react-scaling';
import useTamagotchis from "../hooks/useTamagotchis";
import RatingStats from "../hooks/useRatingStats";


function GenerateRandom(min, max) {
  return Math.floor(Math.random() * (max - min) + min);
}

export default function GameDetails({ selectedGame, goToGame, ShowProgress, gameview, ShowRewards, sceneview, ShowGameView }) {

  var ratings = RatingStats();
  const [myRating, setMyRating] = useState(1);

  useEffect(() => {
    if (ratings !== undefined) {
      //console.log("DID IT DO THIS?");
      setMyRating(GetRating(selectedGame.id));
    }
  }, [selectedGame]);

  function GetRating(id) {
    var myrate = 0;
    for (let i = 0; i < ratings.length; i++) {
      if (ratings[i].service_id == id) {
        myrate = ratings[i].rating;
        //convert myrate to level number between 1-10

        myrate = Math.round(myrate / 150);

        console.log("MY RATING IS: " + myrate);

        if (myrate > 10)
          myrate = 10;
      }
    }
    console.log(myrate);
    return myrate;
  }


  function RewardsView(id, difficulty) {
    var level = 0;
    var totalExp = 0;
    var expRemainder = 0;
    var expNeeded = 0;
    var wd = 0 + "%";

    var rewardsCheckpoints = [0, 1000, 3000, 6000, 10000, 15000];
    var rewardRanks = ["Beginner", "Novice", "Amateur", "Adept", "Expert", "Master"];

    console.log(selectedGame);
    if (tamagotchis.xp !== undefined) {
      for (let i = 0; i < tamagotchis.xp.length; i++) {
        if (id == tamagotchis.xp[i].galaxyID) {
          totalExp = tamagotchis.xp[i].playerEXP;
          expRemainder = totalExp;
          break;
        }
      }
    }
    if (rewardsCheckpoints !== undefined) {
      for (let i = 0; i < rewardsCheckpoints.length; i++) {
        if (expRemainder >= rewardsCheckpoints[i]) {
          level++;
          expRemainder -= rewardsCheckpoints[i];
        }
        else {
          expNeeded = rewardsCheckpoints[i];
          break;
        }
      }
    }

    var xpText = "";
    if (level < 6)
      xpText = expRemainder.toString() + "/" + expNeeded.toString() + " xp";
    else
      xpText = "Maximum level reached.";

    wd = (((level - 1) * 20) + ((expRemainder / expNeeded) * 20)) + "%";
    if (((level - 1) * 20) + ((expRemainder / expNeeded) * 20) < 4) {
      wd = "4%";
    }

    //function to get gold or grey gem
    function GetGem(input) {
      if (level - 1 >= input) {
        return ShinyGem
      }
      else {
        return GreyGem
      }
    }

    //loop through set gems
    var html
    var rightPos = 69;
    var rightmodifier = -13.75;
    for (let i = 0; i < 6; i++) {
      html +=
        '<img src="' + GetGem(i) + '"' + "style='font-size:20px ; color:#815B37FF; position:absolute;  right:" + rightPos + "%'></img>";
      rightPos += rightmodifier;

    }

    function MapGems() {
      let table = [];
      var padding = "125px";
      for (let i = 0; i < 1; i++) {
        let children = []
        //Inner loop to create children
        for (let j = 0; j < 6; j++) {
          if (j == 4) {
            padding = "150px";
          }
          if (j !== 0) {
            children.push(<td style={{ paddingLeft: "0px", paddingRight: padding }}><img src={GetGem(j)}></img></td>)
          } else {
            children.push(<td style={{ paddingLeft: "0px", paddingRight: "125px" }}><img style={{ position: "relative", left: "-15px" }} src={GetGem(j)}></img></td>)
          }

        }
        //Create the parent and add the children
        table.push(<tr>{children}</tr>)
      }
      return table
    }

    function dateDiffInDays(a, b) {
      // Discard the time and time-zone information.
      const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
      const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

      return Math.floor((utc2 - utc1) / _MS_PER_DAY);
    }

    const _MS_PER_DAY = 1000 * 60 * 60 * 24;

    var date = new Date()
    console.log("todays date is: " + date.getUTCDate());

    var endDate = new Date(2022,9,20);
    console.log("end day date is: " + endDate.getUTCDate());

    var daysRemaining = dateDiffInDays(date, endDate);

    var daysRemainingText = "";
    if (daysRemaining >= 0)
      daysRemainingText = "This season ends in " + daysRemaining + " days";
    else
      daysRemainingText = "This season has ended";

    return (
      <ProgressContainer>
        <Scale scaleTo={1720}>
          <div >
            <br /> <br /><br />
            <h1 style={{ fontSize: "4.6em", textAlign: "center" }}>{selectedGame.description} </h1>
            <br /> <br /><br />
            <h1 style={{ fontSize: "3em", textAlign: "center" }}>{"Your Rank: " + rewardRanks[level - 1]} </h1>
            <br /> <br /><br />
            <h1 style={{ fontSize: "3em", textAlign: "center" }}>{daysRemainingText} </h1>
            <br /> <br /><br />
            <h1 style={{ fontSize: "3em", textAlign: "center" }}>{xpText} </h1>
            <br /> <br /><br />

            <div style={{ width: "100%" }}>
              <ExpBar>
                <ExpFiller style={{ width: wd }}>
                  {MapGems()}
                  <div dangerouslySetInnerHTML={{ __html: "" }}></div>
                </ExpFiller>
              </ExpBar>
            </div>

            <br /><br />
            <Button style={{ width: "30%", marginRight: "30%" }} onClick={ShowGameView}>{`Back`}</Button>
          </div>
        </Scale>
      </ProgressContainer>
    )
  }


  const tamagotchis = useTamagotchis();

  const [difficultyLevel, setDifficultyLevel] = useState(1);

  if (sceneview == 2) {
    var levelID = selectedGame.id;
    return RewardsView(levelID, difficultyLevel);
  }
  else {
    return selectedGame !== null ? (
      <GameDetailsContainer>
        <Scale scaleTo={1720}>
          <div>
            <h1>{selectedGame.description}</h1>

            <div style={{ display: "flex" }}>
              <InfoContainer>
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                  {selectedGame.playable ? (
                    <Button style={{ width: "65%" }} onClick={goToGame}>{`Go to ${selectedGame.name}`}</Button>
                  ) : (
                      <LinkButton
                        style={{ width: "65%" }}
                        href={process.env.REACT_APP_DOWNLOAD_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Disabled
            </LinkButton>
                    )}
                </div>
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                <img
                  style={{ marginTop: "20px", marginLeft: "0%", width: "700px"}}
                  src={selectedGame.background}
                  alt="game preview"
                />
                {selectedGame.id != "22" && selectedGame.id != "23" && selectedGame.id != "38" && selectedGame.id != "39" ?(<div style={{display: "flex"}}><MenuContainer style={{marginTop: "20px", marginLeft: "10%", width: "70%", fontSize: "3em", border: "2px solid grey", borderRadius: "5px"}}>
                  <div  style={{ textAlign: "center", marginTop: "20px"}}>Rating: {myRating}</div>
                </MenuContainer>
                <MenuContainer style={{display: "none", marginTop: "20px", marginLeft: "10%", width: "20%", fontSize: "3em", border: "2px solid grey", borderRadius: "5px"}}>
                <div  style={{ textAlign: "center", marginTop: "20px"}}>Rating: {myRating}</div>
              </MenuContainer></div>
                )
                : (<div></div>)}
                </div>
                <p>{selectedGame.instructions}</p>
              </InfoContainer>
            </div>
          </div>
        </Scale>
      </GameDetailsContainer>
    ) : (
        <GameDetailsContainer />
      );
  }
}

const ExpBar = styled.div`
background: #ffffff;
height: 50px;
border-radius: 100px;
border: 1px solid #333;
`

const ExpFiller = styled.div`
background: #ff9500;
height: 50px;
border-radius: 50px;
transition@ width .2s ease-in;
`

const LevelListContainer = styled.div`
  max-height: 60%;
  height: 60%;
  width: 50%;
  overflow: auto;
  float: left;
  
  table, th, td {
    border: 1px solid black;
    border-collapse: collapse;
  }

  h4 {
    margin: 0px;
  }

  button {
    margin-top: 0px;
    width: 90%;
  }
  div::-webkit-scrollbar-track {
    background-color: #000000;
  }
  
  div::-webkit-scrollbar {
    width: 50px;
}
  
  div::-webkit-scrollbar-thumb {
    background-color: #333333;
  }


`;

const LevelButton = styled(Button)`
    text-align: center;
    width: 10%;
    height: 70px;
    margin: 5px;
    color: #fff;
    user-select: none;
    background: ${props => (props.active ? "#673b8b," : "rgb(234, 146, 19)")};
    background: ${props =>
    props.active
      ? "linear-gradient(0deg, #673b8b, #683d8c)"
      : "linear-gradient(0deg,rgba(234, 146, 19, 1) 0%,rgba(255, 186, 32, 1) 100%)"};
    border: 2px solid ${props => (props.active ? "#673b8b" : "#e88f12")};

    padding: 0.5em;
    box-sizing: border-box;
    border-radius: 0em;
    font-size: 3em;
    cursor: ${props => (props.active ? "pointer" : "")};
    @media (min-width: 1025px) and (max-width: 1440px) {
        font-size: 2.5em;
    }

    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
        margin-bottom: 0;
    }
`;

const Label = styled.label`
  display: block;
  position: relative;
  padding-left: 2em;
  height: 1em;
  line-height: 30px;
  cursor: pointer;
  user-select: none;
  color: #673b8b;
  font-size: ${props => (props.bold ? "25px" : "18px")};
  font-weight: ${props => (props.bold ? "900" : "300")};
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }
  &:hover {
    input ~ span {
      background-color: ${props => props.theme.primary};
    }
  }
  input:checked ~ span {
    background-color: ${props => props.theme.primary};
    &:after {
      display: block;
    }
  }
`;